import React from 'react';

export const MedicarePartADenialProofDescription = () => (
  <>
    <p>
      This applicant is age 65 or older. You selected they don’t have Medicare
      Part A.
    </p>
    <p>
      You’ll need to submit a copy of a letter from the Social Security
      Administration. This confirms they don’t qualify for Medicare benefits
      under anyone’s Social Security number.
    </p>
  </>
);

export const MedicareProofOfIneligibilityDescription = () => (
  <>
    <p>
      You’ll need to submit a copy of a letter from the Social Security
      Administration that confirms the applicant doesn’t qualify for Medicare
      benefits under anyone’s Social Security number.
    </p>
    <p>
      If more than one applicant has proof of Medicare ineligibility, you can
      submit them all at once.
    </p>
  </>
);
